import { Routes } from "@angular/router";
import { PageComponent } from "./core/page/page.component";
import { IconsPageComponent } from "./pages/icons-page/icons-page.component";
import { ModalsPageComponent } from "./pages/modals-page/modals-page.component";
import { DialogsPageComponent } from "./pages/dialogs-page/dialogs-page.component";
import { BreakpointsPageComponent } from "./pages/breakpoints-page/breakpoints-page.component";
import { AlertsPageComponent } from "./pages/alerts-page/alerts-page.component";
import { ThemesPageComponent } from "./pages/themes-page/themes-page.component";
import { BannerPageComponent } from './pages/banner-page/banner-page.component';
import { TogglesPageComponent } from "./pages/toggles-page/toggles-page.component";
import { FormsPageComponent } from './pages/forms-page/forms-page.component';
import { HeaderFooterPageComponent } from "./pages/header-footer-page/header-footer-page.component";
import { PaginationPageComponent } from "./pages/pagination-page/pagination-page.component";

export const appRoutes: Routes = [
    {path: '', component: PageComponent},
    {path: 'icons', component: IconsPageComponent},
    {path: 'modals', component: ModalsPageComponent},
    {path: 'dialogs', component: DialogsPageComponent},
    {path: 'breakpoints', component: BreakpointsPageComponent},
    {path: 'alerts', component: AlertsPageComponent},
    {path: 'themes', component: ThemesPageComponent},
    {path: 'banners', component: BannerPageComponent},
    {path: 'toggles', component: TogglesPageComponent},
    {path: 'forms', component: FormsPageComponent},
    {path: 'header-footer', component: HeaderFooterPageComponent},
    {path: 'pagination', component: PaginationPageComponent},
    {path: ':page', component: PageComponent}
];